import React from "react";
import styled from "styled-components";
import ButtonSM from "../../../common/buttons/buttonSM";
import EntitiesCarousel from "../../../common/carousels/entitiesCarousel";

/* #region CSS */
const StyledPage = styled.div`
    &.frame-1000011156,
    &.frame-1000011156 * {
        box-sizing: border-box;
    }
    &.frame-1000011156 {
        padding: 30px 32px 30px 32px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        height: 555px;
    }
    .frame-1000011157 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        position: relative;
        width: 100%;
    }
    .frame-1000011153 {
        display: flex;
        flex-direction: column;
        gap: 40px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 517px;
        position: relative;
    }
    .frame-313730 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313706 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 41px;
        position: relative;
    }
    .title {
        color: #f7665f;
        text-align: left;
        font-family: "ITC Avant Garde Gothic";
        font-size: 30px;
        line-height: 30px;
        font-weight: 500;
        position: relative;
    }
    .frame-313707 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 41px;
        position: relative;
    }
    .description {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "ITC Avant Garde Gothic";
        font-size: 16px;
        line-height: 20px;
        font-weight: 100;
        position: relative;
    }
    .frame-313708 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-text-group {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 40px;
    }
    @media (min-width: 993px) and (max-width: 1199px) {
        &.frame-1000011156 {
            height: 460px;
        }
        .frame-1000011153 {
            height: 400px;
        }
    }
    @media (min-width: 750px) and (max-width: 992px) {
        &.frame-1000011156 {
            padding: 16px 16px;
            height: 290px;
        }
        .frame-1000011153 {
            height: 221px;
            gap: 30px;
        }
        .btn-text-group {
            flex-direction: row;
            justify-content: space-between;
        }
        .title {
            font-size: 16px;
        }
    }
    @media (max-width: 749px) {
        &.frame-1000011156 {
            height: 230px;
            padding: 16px 16px;
        }
        .frame-1000011153 {
            height: 200px;
        }
        .btn-text-group {
            flex-direction: row;
            justify-content: space-between;
        }
        .title {
            font-size: 16px;
        }
    }
`;
/* #endregion CSS */

export default function EntitiesSection({
    title = "--",
    description = "",
    entities = [],
    showDescriptionInMobile = false,
    buttonTitle = "--",
    buttonOnClick = undefined,
    onEntityClick = undefined,
    isLoading = false
}) {
    return (
        <StyledPage className="frame-1000011156">
            <div className="frame-1000011157">
                <div className="frame-1000011153">
                    <div className="btn-text-group">
                        <div className="frame-313730">
                            <div className="frame-313706">
                                <div className="title">{title}</div>
                            </div>

                            {!showDescriptionInMobile && (
                                <div className="frame-313707">
                                    <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
                                </div>
                            )}
                        </div>

                        <div className="frame-313708">
                            <ButtonSM title={buttonTitle} onClick={buttonOnClick} />
                        </div>
                    </div>
                    <EntitiesCarousel entities={entities} onEntityClick={onEntityClick} isLoading={isLoading} />
                </div>
            </div>
        </StyledPage>
    );
}
